/* ¿El furgón tiene lona?
 *
 * ── POR QUÉ ESTO ES UN MÓDULO Y NO UN `? "Sí" : "No"` ────────────────────
 *
 * Porque son TRES estados y no dos, y el tercero es el que más importa el
 * primer día: **de los 679 furgones, ninguno tiene el dato cargado**. Se
 * buscó antes de crear la columna —`lona` y `sider` dan cero coincidencias en
 * el detalle, la marca y el modelo del padrón, en los 5.158 `obs` de
 * movimientos, en la ticketera y en las estadías de taller— así que no hay de
 * dónde deducirlo: se carga a mano, de a poco.
 *
 * Y mientras eso pasa, `sin dato` tiene que verse como lo que es. Dibujado
 * igual que «no tiene», la lista de furgones sin lona arranca con la flota
 * entera adentro y el trabajo de cargarlos no se ve nunca. Es la misma regla
 * que ya vale para el psicofísico sin fecha, para las 86 unidades que no
 * reportaron urea y para los cuatro estados de la última ubicación: **«no
 * sabemos» no se dice como «no»**.
 *
 * ── Y VIVE EN UN SOLO LUGAR ──────────────────────────────────────────────
 *
 * Lo leen el padrón, la ficha del furgón y la pantalla de acoplados. Con la
 * traducción escrita en cada una, el día que se agregue un estado —o que
 * cambie cómo se dice «sin dato»— dos pantallas dirían cosas distintas del
 * mismo furgón. Es la razón por la que `Ubicacion`, `ChipUsuario` y
 * `VeredictoRTO` salieron de adentro de sus pantallas.
 */

import { tresEstados, SI, NO } from "./tresEstados";

export const CON_LONA = "con";
export const SIN_LONA = "sin";
export const SIN_DATO = "sin_dato";

/* El orden en el que se ofrecen y se cuentan. `sin_dato` va ÚLTIMO en la
 * lista de opciones —no es una opción que alguien elija, es el estado en el
 * que están— y PRIMERO en los conteos, porque es el que hay que resolver. */
export const ESTADOS = [
  { clave: CON_LONA, etiqueta: "Con lona", corto: "Con" },
  { clave: SIN_LONA, etiqueta: "Sin lona", corto: "Sin" },
  { clave: SIN_DATO, etiqueta: "Sin dato", corto: "—" },
];

/* De lo que hay en la fila al estado.
 *
 * LA LECTURA VIVE EN `tresEstados.js` y no acá. Es la misma que necesita
 * `puerta` —la otra columna que carga Federico desde `/FurgonesApp`— y
 * copiada serían dos lugares donde entender el string `"false"`, que es
 * VERDADERO en JavaScript y ya nos mordió en `estado.js`. Las etiquetas sí
 * son de la lona: lo compartido es cómo se LEE, no cómo se dice. */
export function estadoLona(valor) {
  const e = tresEstados(valor);
  if (e === SI) return CON_LONA;
  if (e === NO) return SIN_LONA;
  return SIN_DATO;
}

/* Cómo se dice. `sin dato` NO dice «No»: dice que falta cargarlo. */
export function etiquetaLona(valor) {
  const e = ESTADOS.find((x) => x.clave === estadoLona(valor));
  return e ? e.etiqueta : "Sin dato";
}

/* Cuántos hay de cada uno, con los que faltan adelante.
 *
 * DEVUELVE TAMBIÉN EL TOTAL Y LOS QUE FALTAN por separado: «12 con lona» sobre
 * una flota de 679 se lee muy distinto de «12 con lona, 667 sin cargar», y sin
 * el segundo número el primero parece un inventario terminado. Es la misma
 * regla que la cobertura del historial de AdBlue. */
export function contar(furgones) {
  const out = { [CON_LONA]: 0, [SIN_LONA]: 0, [SIN_DATO]: 0 };
  for (const f of furgones || []) out[estadoLona(f?.lona)] += 1;
  return {
    ...out,
    total: (furgones || []).length,
    faltan: out[SIN_DATO],
  };
}
